<agr-page-toolbar
  [pageTitle]="pageTitle()"
  [hasPrimaryAction]="isAdvisor()"
  primaryActionIcon="add"
  [primaryActionText]="'add' | translate"
  (primaryAction)="onButtonCreate()"
  [emptyTitle]="'reference-value-sheet.overview.empty.title' | translate"
  [emptyDescription]="'reference-value-sheet.overview.empty.description' | translate"
  emptyImage="assets/images/flock-cycle.jpg"
  [isEmpty]="refValSheets()?.length === 0"
  data-test="value-sheet__overview"
>
  <ng-container actions *ngIf="isStandardRefValSheet()">
    <div class="flex__child--auto spacing--margin-right flex--row text--small">
      <mat-form-field
        class="flex__child--auto spacing--margin-right countrySelector"
        subscriptSizing="dynamic"
      >
        <mat-select
          [hideSingleSelectionIndicator]="true"
          class="text--small"
          data-placeholder="{{ 'standard-reference-value-sheet.overview.country' | translate }}"
          data-test="standard-reference-value-sheet-overview-country-selector"
          (selectionChange)="changeCountrySelection($event)"
          [value]="selectedCountry()"
        >
          <mat-option *ngFor="let country of countries" [value]="country.id">
            {{ 'countries.' + country.id | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

  <div *ngIf="!isServer" class="wrapper--spacing-horizontal wrapper--spacing-vertical">
    <agr-table [config]="tableConfig()"> </agr-table>
    <ng-template #columnActiveTemplate let-row="row">
      <mat-slide-toggle
        [hideIcon]="true"
        data-test="value-sheet__overview-toggle-active"
        color="primary"
        [disabled]="!isAdvisor()"
        [checked]="row.isActive"
        (change)="onToggleActive(row)"
      >
      </mat-slide-toggle>
    </ng-template>
    <ng-template #columnNameTemplate let-row="row">
      <button
        mat-button
        class="button--text"
        (click)="onViewRefValSheet(row)"
        [attr.data-test]="'value-sheet__view-button_' + row.name"
      >
        {{ row.name }}
      </button>
    </ng-template>
  </div>
</agr-page-toolbar>
